<template>
  <div class="page page2 tg-video">
    <van-form @submit="submitForm">
      <div class="tg-video-hd">视频投稿</div>
      <div class="form">
        <div class="info-ipt">
          <van-field
            class="required"
            v-model="form.mname"
            name="作品名称"
            label="作品名称"
            maxlength="15"
            placeholder="请输入15字以内作品名称"
            :rules="[{ required: true, message: '作品名称不能为空' }]"
          />
          <van-field
            class="required"
            v-for="(item, index) in custom_fields"
            v-model="form.custom_fields[index]"
            :key="index"
            :name="item"
            :label="item"
            :placeholder="'请输入' + item"
            :rules="[{ required: true, message: item + '不能为空' }]"
          />
          <van-field
            v-model="form.remark"
            rows="5"
            autosize
            label="作品描述"
            type="textarea"
            maxlength="500"
            placeholder="请输入作品描述"
            show-word-limit
          />
        </div>
        <div class="uplvideo-box">
          <div class="box-1" v-show="!isUploadedVideo">
            <van-uploader
              class="btn btn-uplvideo"
              id="uploadVideo"
              :before-read="beforeUploadVideo"
              :after-read="handleVideoUpload"
              :accept="videoType.join(',')"
            >
              <img :src="uploadVideoBg" />
            </van-uploader>
            <!-- <a href="javascript:void(0)">
            <img :src="uploadVideoBg" />
          </a>
          <input class="file" type="file" id="uplvideo" accept="video/mp4" /> -->
          </div>
          <div class="box-2" v-show="isUploadedVideo">
            <div class="filename">{{ videoName }}</div>
            <div class="upl-progress">
              <div class="progress-bar">
                <div
                  class="progress-cur"
                  :style="'width: ' + videoUploadPercent + '%'"
                ></div>
              </div>
              <div class="progress-txt">{{ videoUploadPercent }} %</div>
            </div>
            <a class="btn-cancel" href="javascript:;" @click="cancelVideoUpload"
              >取消上传</a
            >
          </div>
        </div>
        <div class="upl-cover">
          <van-uploader
            ref="uploadFile"
            class="cover"
            :after-read="handleCoverUpload"
            :before-read="beforeCoverUpload"
          >
            <img class="cover" :src="imageUrl" />
            <van-loading size="24px" type="spinner" vertical v-show="loading"
              >上传中...</van-loading
            >
            <!-- <input type="file" id="uplcover" accept="image/jpeg" /> -->
          </van-uploader>
          <div class="input-wrap" @click="changePhotos"></div>
        </div>
        <div class="tips" v-if="msg != ''">
          {{ msg }}
        </div>
        <div class="submit-item">
          <div class="agreement-tips">
            发布即表示您已同意我们的<a
              href="https://www.pai2345.com/wap/treaty/index/id/9"
              >原创条款</a
            >
          </div>
        </div>

        <div class="submit-item">
          <van-button class="btn-submit" native-type="submit">提交</van-button>
        </div>
      </div>
    </van-form>
    <ChooseFile
      :chooseForm1="chooseForm1"
      :uploadImages="uploadImages"
      :limit="1"
      :max="1"
      :chooseType="chooseType"
      @changeChooseForm1="changeChooseForm1"
      @changeChooseForm2="changeChooseForm2"
      @chooseFromSys="chooseFromSys"
      @chooseComplete="chooseComplete"
    />
  </div>
</template>

<script>
import ChooseFile from "@/components/ChooseFile";
export default {
  components: {
    ChooseFile,
  },
  data() {
    return {
      id: this.$route.params.id,
      group: this.$route.query.group,
      custom_fields: [],
      form: {
        work_id: this.$route.query.work_id,
        match_id: this.$route.params.id,
        mname: "",
        remark: "",
        image: "",
        group: this.$route.query.group,
        custom_fields: [],
        video: "",
        // image: this.imageUrl,
        // group: this.group,
        // shoot_address: this.form.shoot_address,
        // custom_fields: this.form.custom_fields,
        works_type: 4,
      },
      videoType: ["video/mp4"],
      formData: {},
      uploadVideoBg: require("@/static/images/1224/btn-1.png"),
      imageUrl: require("@/static/images/1223/video-cover.png"),
      imageBg: require("@/static/images/1223/video-cover.png"),
      isShowTips: false,
      loading: false,
      isUploadedVideo: false,
      videoUploadPercent: 0,
      ossParams: {},
      videoUrl: "/aly",
      videoName: "文件名",
      msg: "",
      //图片的限定
      gourp_limit: {
        typestr: "",
        size: 20,
        end: 2,
        start: 1,
        imgtype: [],
        is_open_psd: 0,
      },
      isShowProgress: false,
      chooseForm1: false,
      chooseForm2: false,
      uploadImages: [],
      chooseType: "single",
    };
  },
  methods: {
    changePhotos() {
      this.chooseForm1 = true;
      this.uploadImages = [];
      this.uploadImages.push({ url: this.form.image });
    },
    changeChooseForm1(val) {
      this.chooseForm1 = val;
    },
    changeChooseForm2(val) {
      this.chooseForm2 = val;
    },
    chooseFromSys() {
      this.$refs.uploadFile.chooseFile();
    },
    chooseComplete(val) {
      // console.log(val);
      if (val && val.length > 0) {
        this.imageUrl = val[0].up_url;
        this.form.image = val[0].up_url;
        // this.isUploaded = true;
        // this.loading = false;
        this.form.mname = this.form.mname || val[0].title;
        this.form.remark = this.form.remark || val[0].content;
      }
    },
    beforeUploadVideo(file) {
      // console.log(file);
      let video_limit =
        this.gourp_limit.video_limit == 0 ? 300 : this.gourp_limit.video_limit;
      var fileSize = file.size / 1024 / 1024 < video_limit;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1
      ) {
        this.$toast.fail("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        this.$toast.fail("视频大小不能超过 " + video_limit + "MB");
        return false;
      }
      return true;
    },
    // 取消上传
    cancelVideoUpload() {
      // 上传相关的交互置空
      // 普通上传 阿里云接口没有提供取消上传
      this.isUploadedVideo = false;
      this.videoUploadPercent = 0;
      this.form.video = "";
    },
    //进度条percent
    uploadVideoProcess(percent) {
      this.videoUploadPercent = percent;
    },
    handleVideoUpload(files) {
      var file = files.file;
      var _this = this;
      _this.videoName = file.name;
      // 上传事件 放在oss上传过程文件中处理;
      // this.videoUploadPercent = videoParams.videoUploadPercent;
      _this.isUploadedVideo = true;
      var promise = new Promise((resolve, reject) => {
        _this.tools.getMd5(file).then((md5) => {
          _this.axios
            .post(
              "/match/params",
              {
                name: file.name,
                md5: md5,
                dir: "matchVideo",
              },
              // config
            )
            .then(function(response) {
              var params = response.data;
              console.log(params);
              var res = params.data;

              if (params.code == 200) {
                _this.ossParams = res;
                file.OSSAccessKeyId = res.id;
                file.policy = res.policy;
                file.signature = res.signature;
                file.success_action_status = "200";
                file.callback = "";
                file.key = res.key;
                file.host = res.url;
                file.url = res.url;
                //打包时候需要打开
                _this.videoUrl = res.url;
              }
              file.key = res.key;
              file.host = res.url;
              file.progress = 0;
              file.imgUrl = "";
              _this.tools.callbackOssVideo(file, _this.uploadVideoProcess, function(res) {
                if (res) {
                  // console.log(file);
                  _this.handleVideoSuccess(file);
                  resolve(res);
                } else {
                  reject(false);
                }
              });
            })
            .catch(function(error) {
              console.log(error, "错误");
              reject(error);
            });
        });
      });
      return promise;

      // console.log(file);
      // this.tools.callbackOss(file.file, function(res) {
      //   if (res) {
      //     this.handleVideoSuccess(file);
      //   }
      // });
    },
    //上传成功回调
    handleVideoSuccess(file) {
      this.videoUploadPercent = this.isUploadedVideo ? 100 : 0;
      this.form.video = this.isUploadedVideo ? file.host + "/" + file.key : "";
      this.videoName = this.isUploadedVideo ? file.name : "";
      // console.log(this.form);
    },
    // triggerUpload() {
    //   document.getElementById("single").click();
    // },
    // clearTips() {
    //   this.isShowTips = false;
    //   console.log(1);
    // },
    // handleAvatarSuccess(res, file) {
    //   // 上传成功改变图片值
    //   this.imageUrl = URL.createObjectURL(file.raw);
    //   // 图片上传成功就隐藏提示框
    //   this.isShowTips = false;
    // },
    beforeCoverUpload(file) {
      const isJPG = this.tools.hasImgType(
        this.gourp_limit.file_limit_type_single,
        file.type
      );
      // const isJPG = file.type === "image/jpeg";
      const isLt2M =
        file.size / 1024 / 1024 < this.gourp_limit.file_limit_single;

      if (!isJPG) {
        this.$toast.fail(
          // "上传图片只能是 " + this.gourp_limit.typestr + " 格式!"
          {
            message:
              "视频封面图片只能是 " +
              this.gourp_limit.file_limit_type.join(", ") +
              " 格式!",
            duration: 3000,
            className: "long-toast",
          }
        );
      }
      if (!isLt2M) {
        this.$toast.fail(
          // "上传图片大小不能超过 " + this.gourp_limit.file_limit_single + "MB!"
          {
            message:
              "视频封面图片大小不能超过 " +
              this.gourp_limit.file_limit_single +
              "MB!",
            duration: 3000,
            className: "long-toast",
          }
        );
      }
      return isJPG && isLt2M;
    },
    handleCoverUpload(option) {
      var file = option.file;
      file.status = "uploading";
      file.message = "上传中...";
      this.loading = true;
      this.tools.uploadaly(file).then((res) => {
        if (res) {
          this.imageUrl = res;
          this.form.image = res;
          this.loading = false;

          // 上传成功，撤销图库选择状态
          sessionStorage.removeItem("checkVal");
        } else {
          console.log(res);
        }
      });
    },
    submitForm() {
      if (!this.$store.state.isLogin) {
        /* eslint-disable */
        // 调用passport
        passportLogin.login();
        /* eslint-enable */
        return false;
      }
      // let that = this;
      // this.$refs["form"].validate((valid) => {
      // if (valid) {
      // console.log("提交表单：", this.form, this.custom_fields);
      let valid = true;
      // if (this.form.mname == "") {
      //   valid = false;
      //   this.$toast.fal("作品名称不能为空");
      //   return false;
      // }
      // console.log(this.form);
      if (this.form.video == "") {
        valid = false;
        this.$toast.fail("请上传视频");
        return false;
      }

      if (this.form.image == "") {
        valid = false;
        this.$toast.fail("请上传视频封面图");
        return false;
      }
      if (valid) {
        this.axios
          .post("/match/join_single", {
            ...this.form,
          })
          .then((res) => {
            if (res.data.code == 200) {
              if (this.form.work_id > 0) {
                // 作品的再投一稿
                this.$router.push({
                  query: {
                    group: this.group,
                  },
                });
              }
              this.$dialog
                .confirm({
                  title: "",
                  message: "投稿成功!",
                  confirmButtonText: "再投一稿",
                  cancelButtonText: "返回赛事页",
                })
                .then(() => {
                  // on confirm
                  window.location.reload();
                })
                .catch((action) => {
                  // on cancel
                  console.log(action);
                  this.$router.push({
                    name: "intro",
                  });
                });
            } else {
              // this.$toast.fail(res.data.msg);
              this.$toast.fail({
                message: res.data.msg,
                duration: 3500,
                className: "long-toast",
              });
            }
          });
      }
    },
  },
  mounted() {
    // 每次加载都清空图库选择状态
    sessionStorage.removeItem("checkVal");
    // 获取比赛详情
    this.tools
      .getMatchDetail({ id: this.id, group: this.group })
      .then((res) => {
        this.custom_fields = res.custom_fields;
        this.msg = res.match_limit.match_introduce;
        var params = res.gourp_limit;
        if (params) {
          this.gourp_limit = Object.assign(this.gourp_limit, params);
        }
      });
    if (this.$route.query.work_id) {
      this.tools
        .getWorksDetail({ work_id: this.$route.query.work_id })
        .then((res) => {
          // console.log(res);
          Object.assign(this.form, res.form);
          // console.log(this.form);
          this.form.image = res.image;
          this.imageUrl = res.image;
          this.videoName = res.form.video;
          this.isUploadedVideo = true;
          this.videoUploadPercent = 100;
        });
    }
  },
};
</script>

<style lang="scss">
.tg-video {
  textarea {
    word-break: break-all;
    word-wrap: break-word;
  }
  .van-field__label {
    width: 180px;
  }
  .required {
    .van-field__label {
      span::after {
        content: "*";
        color: #dd855c;
        position: absolute;
        left: 18px;
        top: 30px;
      }
    }
  }
  .van-uploader {
    height: 375px;
    overflow: hidden;
    &.cover {
      height: 520px;
    }
  }
  .van-uploader__wrapper {
    height: 100%;
  }
  .van-uploader__input-wrapper {
    // width: 100vw;
    height: 100%;
  }
  .van-loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    color: #fff;
    .van-loading__spinner,
    .van-loading__text {
      position: relative;
      top: 45%;
      transform: translateY(-45%);
    }
    .van-loading__text {
      color: #fff;
    }
  }
  .van-button {
    line-height: 1;
  }
  .upl-cover {
    position: relative;
  }
  .input-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.long-toast {
  width: 80%;
  max-width: 80%;
}
</style>
